import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import { InfoCircle, Loader, TableDataNotFound } from 'components';
import { AssetRowItems, TableHeader } from './components';

import { useAppSelector } from 'store';

import { IAssetInfo } from 'types/interfaces';
import { TREASURY_TAB, TREASURY_TAB_DESCRIPTIONS } from '../../../../../../../../constants';
import { TableProBlur } from '../DaoAssetsTable/components/TableProBlur';
import { assetsMockUpData } from './mockupData';

type MetadataTableProps = {
    isBlurred?: boolean;
};
export const MetadataTable: FC<MetadataTableProps> = ({ isBlurred = false }): ReactElement => {
    const { daoAssets, daoAssetsDataLoading } = useAppSelector(({ organization }) => organization);

    const dataToRender = daoAssets?.length && !isBlurred ? daoAssets : assetsMockUpData;
    return (
        <>
            {!daoAssetsDataLoading && daoAssets.length === 0 && !isBlurred && (
                <TableDataNotFound forTable overflowMarginsSecondVariant />
            )}

            {daoAssetsDataLoading && daoAssets.length === 0 && !isBlurred && (
                <div className={styles.loaderBox}>
                    <Loader size={40} className={styles.decisionsLoader} />
                </div>
            )}

            {dataToRender.length > 0 && (
                <div className={styles.tableWrapper}>
                    <div className={styles.titleWrapper}>
                        <h4 className={styles.tableTitle}>Metadata</h4>
                        <InfoCircle
                            tooltipText={TREASURY_TAB_DESCRIPTIONS[TREASURY_TAB.METADATA]}
                            className={styles.infoIcon}
                        />
                    </div>

                    <div className={`${styles.tableContainer} ${isBlurred ? styles.blurred : ''}`}>
                        <div className={styles.table}>
                            <TableHeader />
                            {dataToRender.map((assetItems: IAssetInfo) => (
                                <AssetRowItems
                                    key={assetItems.address + assetItems.url + assetItems.description}
                                    {...assetItems}
                                />
                            ))}
                            {isBlurred && (
                                <TableProBlur
                                    title="DAO Metadata is a DeepDAO Pro feature"
                                    description={TREASURY_TAB_DESCRIPTIONS[TREASURY_TAB.METADATA]}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
